import { render, staticRenderFns } from "./Tzxsck.vue?vue&type=template&id=10d6af6c&scoped=true&"
import script from "./Tzxsck.vue?vue&type=script&lang=js&"
export * from "./Tzxsck.vue?vue&type=script&lang=js&"
import style0 from "./Tzxsck.vue?vue&type=style&index=0&id=10d6af6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d6af6c",
  null
  
)

export default component.exports